module.exports = __webpack_public_path__ + "static/media/example-3.4ad130a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/MensHealthWA/example-3.jpg
// module id = 246
// module chunks = 0